import dynamic from "next/dynamic";

const ClientProductListingNoSSR = dynamic(
  () => import("./ClientProductListing"),
  { ssr: false }
);

export default ClientProductListingNoSSR;
